import {
  AppointmentButton,
  BottomBlock,
  CloseButton,
  ContactBlock,
  ContactImgBlock,
  ContactTextBlock,
  HeaderBlock,
  HeaderContainer,
  LogoImg,
  MiniImg,
  MobileArrow,
  MobileBlockOpen,
  MobileBrandInline,
  MobileContainer,
  MobileLogoWrap,
  MobileLinksContainer,
  MobilePopUp,
  MobileTopBar,
  MobileBrand,
  MobileBrandLogo,
  MobileBrandText,
  MobileNavLink,
  MobileGroup,
  MobileGroupLabel,
  MobileGroupList,
  MobileGroupItem,
  MobileCTAWrap,
  MobileCTA,
  MobileContactSection,
  MobileContactRow,
  MobileContactIcon,
  MobileContactColumn,
  MobileSocialRow,
  StyledFragment,
  Text,
  UpBlock
} from "./styled";
import logo from "./../../images/mechta_logo.png";
import point from "./../../images/point-images/point.png";
import phone from "./../../images/point-images/phone.png";
import mail from "./../../images/point-images/mail.png";
import inst from "./../../images/social/inst.png";
import fb from "./../../images/social/fb.png";
import tg from "./../../images/social/tg.png";
import { routes } from "../../shared/routes/routes";
import { Link } from "react-router-dom";
import {LinkBlockComponent} from "./LinkBlockComponent";
import {useEffect, useState} from "react";

const Links = [
  {
    name: "О НАС",
    route: routes.about,
    toggle: false,
    routes: []
  },
  {
    name: "ПРЕДМЕТЫ И СТУДИИ",
    route: '/',
    toggle: true,
    routes: [{
      name: "Подготовка в Secondorie",
      link: routes.secondorie
    },
      {
        name: "Школа, студии и кружки",
        link:routes.studiesAnd
      },
      {
        name: "Предметы",
        link:routes.subjects
      } ]
  },
  {
    name: "НОВОСТИ",
    route: routes.onlyNews,
    toggle: false,
    routes: []
  },
  {
    name: "КАЛЕНДАРЬ",
    route: routes.calendar,
    toggle: false,
    routes: []
  },
  {
    name: "РАСПИСАНИЕ",
    route: "/",
    toggle: true,
    routes: [{
      name: "Расписание студий и кружков",
      link: routes.raspisanie
    }, {
      name: "Расписание средних и старших классов",
      link: routes.raspisanieHight
    },
      {
        name: "Расписание младших классов",
        link: routes.raspisanieChild
      },
      {
        name: "Расписание подготовительных классов",
        link: routes.raspisaniePodgotovka
      },

      ]
  },
  {
    name: "ЛОГОПЕД И ПСИХОЛОГ",
    route: routes.lap,
    toggle: false,
    routes: []
  },
  {
    name: "БЛАГОТВОРИТЕЛЬНОСТЬ",
    route: routes.charity,
    toggle: false,
    routes: []
  }
];

export const Header = () => {
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    document.body.style.overflow = toggle ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [toggle]);

  const close = () => setToggle(false);

  return (
    <HeaderContainer>
      <StyledFragment>
        <UpBlock>
          <HeaderBlock>
            <Link to={routes.index}>
              <LogoImg src={logo} />
            </Link>
          </HeaderBlock>
          <HeaderBlock>
            <ContactBlock>
              <ContactImgBlock>
                <MiniImg src={point} />
              </ContactImgBlock>
              <ContactTextBlock>
                4245 Decarie Blvd, Montreal, QC H4A 3K4
              </ContactTextBlock>
            </ContactBlock>
            <ContactBlock>
              <ContactImgBlock>
                <MiniImg src={phone} />
              </ContactImgBlock>
              <ContactTextBlock>
                <Text>+1(514)772-50-12</Text>
                <Text>+1(514)795-46-77</Text>
                <Text>+1(514)712-50-12</Text>
              </ContactTextBlock>
            </ContactBlock>
            <ContactBlock>
              <ContactImgBlock>
                <MiniImg src={mail} />
              </ContactImgBlock>
              <ContactTextBlock>director@mechtacenter.org</ContactTextBlock>
            </ContactBlock>
          </HeaderBlock>
          <HeaderBlock>
            <Link to={routes.appointment} >
            <AppointmentButton>Запись в школу</AppointmentButton>
            </Link>
          </HeaderBlock>
        </UpBlock>
        <BottomBlock>
          {Links.map((value) => {
            return (
              <LinkBlockComponent name={value.name} route={value.route} toggle={value.toggle} routes={value.routes}/>
            );
          })}
        </BottomBlock>
      </StyledFragment>
      <MobileContainer>
        <HeaderBlock>
          <MobileLogoWrap to={routes.index}>
            <img src={logo} alt="Мечта" />
          </MobileLogoWrap>
          <MobileBrandInline>
            <strong>Школа «Мечта»</strong>
            <span>Русская школа в Монреале</span>
          </MobileBrandInline>
        </HeaderBlock>
        <MobileBlockOpen onClick={() => setToggle(!toggle)} aria-label="Открыть меню">
          <MobileArrow/>
          <MobileArrow/>
          <MobileArrow/>
        </MobileBlockOpen>
        {toggle && (
          <MobilePopUp>
            <MobileTopBar>
              <MobileBrand>
                <MobileBrandLogo src={logo} alt="Мечта" />
                <MobileBrandText>
                  <strong>Школа «Мечта»</strong>
                  <span>Русская школа в Монреале</span>
                </MobileBrandText>
              </MobileBrand>
              <CloseButton onClick={close} aria-label="Закрыть меню">
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
                  <path
                    d="M6 6L18 18M18 6L6 18"
                    stroke="currentColor"
                    strokeWidth="2.4"
                    strokeLinecap="round"
                  />
                </svg>
              </CloseButton>
            </MobileTopBar>

            <MobileLinksContainer>
              {Links.map((item) =>
                item.toggle ? (
                  <MobileGroup key={item.name}>
                    <MobileGroupLabel>{item.name}</MobileGroupLabel>
                    <MobileGroupList>
                      {item.routes.map((sub) => (
                        <MobileGroupItem key={sub.link} to={sub.link} onClick={close}>
                          {sub.name}
                        </MobileGroupItem>
                      ))}
                    </MobileGroupList>
                  </MobileGroup>
                ) : (
                  <MobileNavLink key={item.name} to={item.route} onClick={close}>
                    <span>{item.name}</span>
                    <svg viewBox="0 0 14 10" xmlns="http://www.w3.org/2000/svg" fill="none">
                      <path
                        d="M1 5H13M13 5L9 1M13 5L9 9"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </MobileNavLink>
                )
              )}
            </MobileLinksContainer>

            <MobileCTAWrap>
              <MobileCTA to={routes.appointment} onClick={close}>
                Запись в школу
                <svg viewBox="0 0 14 10" xmlns="http://www.w3.org/2000/svg" fill="none">
                  <path
                    d="M1 5H13M13 5L9 1M13 5L9 9"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </MobileCTA>
            </MobileCTAWrap>

            <MobileContactSection>
              <MobileContactRow>
                <MobileContactIcon>
                  <img src={point} alt="" />
                </MobileContactIcon>
                <span>4245 Decarie Blvd, Montreal, QC H4A 3K4</span>
              </MobileContactRow>
              <MobileContactRow>
                <MobileContactIcon>
                  <img src={phone} alt="" />
                </MobileContactIcon>
                <MobileContactColumn>
                  <a href="tel:+15147725012">+1 (514) 772-50-12</a>
                  <a href="tel:+15147954677">+1 (514) 795-46-77</a>
                  <a href="tel:+15147125012">+1 (514) 712-50-12</a>
                </MobileContactColumn>
              </MobileContactRow>
              <MobileContactRow>
                <MobileContactIcon>
                  <img src={mail} alt="" />
                </MobileContactIcon>
                <a href="mailto:director@mechtacenter.org">director@mechtacenter.org</a>
              </MobileContactRow>
              <MobileSocialRow>
                <a href="https://www.instagram.com/mechtamtl" target="_blank" rel="noreferrer" aria-label="Instagram">
                  <img src={inst} alt="" />
                </a>
                <a href="https://www.facebook.com/centermechta/" target="_blank" rel="noreferrer" aria-label="Facebook">
                  <img src={fb} alt="" />
                </a>
                <a href="https://t.me/russian_school_mechta" target="_blank" rel="noreferrer" aria-label="Telegram">
                  <img src={tg} alt="" />
                </a>
              </MobileSocialRow>
            </MobileContactSection>
          </MobilePopUp>
        )}
      </MobileContainer>
    </HeaderContainer>
  );
};
